import type { ReportDialogStep } from '@/reporting/util';
import type { WiwState } from '@/store';

export const getReportNextDialog = (state: WiwState): ReportDialogStep | undefined =>
  state.reporting.customReportBuilder.nextDialog;
